import React from 'react';
import { Button } from '@progress/kendo-react-buttons';

import { TradeCard } from '.';
import { ItemAchievement } from '../inventory';
import { PlayerContext } from '../../../../../../contexts/player';
import { TradeStateContext } from '../../../../../../contexts/trade';
import { PostTradeActionAsync } from '../../../../../../services/trade';
import { GameDocumentContext } from '../../../../../../contexts/game-document';
import { PlayerState } from '../../../../../../types/state/player/player-state';
import { GetItemAchievement } from '../../../../../../utils/game-engine/inventory';
import { generateTitleById } from '../../../../../../utils/game-document/display-languages';
import { DisplayLanguageContext } from '../../../../../../contexts/display-languages';

interface ReceivedItemsProps {
  tradePlayer: PlayerState | undefined;
  showModal: React.Dispatch<React.SetStateAction<ItemAchievement | undefined>>;
}

const ReceivedItems: React.FC<ReceivedItemsProps> = ({
  tradePlayer,
  showModal
}) => {
  const [gameDocument] = React.useContext(GameDocumentContext);
  const [player] = React.useContext(PlayerContext);
  const [trade] = React.useContext(TradeStateContext);
  const [displayLanguageContext] = React.useContext(DisplayLanguageContext);
  const [receivedItems, setReceivedItems] = React.useState<ItemAchievement[]>(
    []
  );
  const playerCode = player.playerState?.code ?? '';
  const tradeRole = playerCode === trade.offerPlayerCode ? 'offer' : 'respond';
  const offeredTradeStatus =
    tradeRole === 'offer' ? trade.offerPlayerStatus : trade.requestPlayerStatus;
  const receivedTradeStatus =
    tradeRole === 'offer' ? trade.requestPlayerStatus : trade.offerPlayerStatus;

  const onAccept = async () => {
    try {
      await PostTradeActionAsync(
        trade.gameCode,
        String(trade.id),
        playerCode === trade.offerPlayerCode ? 'offer' : 'respond',
        'accept'
      );
    } catch (error) {
      console.log(error, '>>>>error when accept trade');
    }
  };

  React.useEffect(() => {
    if (gameDocument.gameDocument && trade.receivedItems) {
      setReceivedItems(
        trade.receivedItems.map((i) =>
          GetItemAchievement(
            gameDocument.gameDocument!,
            player.playerState?.language.name ?? '',
            i.itemId,
            i.quantity
          )
        )
      );
    }
  }, [
    trade.receivedItems,
    gameDocument.gameDocument,
    player.playerState?.language.name
  ]);

  return (
    <>
      <div className={'d-flex justify-content-between align-items-center'}>
        <span>{tradePlayer?.name}'s offer</span>
        <Button
          themeColor={'success'}
          onClick={onAccept}
          disabled={
            offeredTradeStatus !== 'Pending' || receivedTradeStatus === 'Draft'
          }>
          {generateTitleById(
            '2c3d4e5f-6a7b-8c9d-0e1f-2a3b4c5d6e7f',
            gameDocument,
            displayLanguageContext.displayLanguageSelected.resources!,
            'game'
          ) || 'Accept trade'}
        </Button>
      </div>
      <div
        className={'d-flex flex-grow-1 flex-column gap-2'}
        style={{
          borderRadius: '12px',
          backgroundColor: '#e9f9f5',
          padding: '12px',
          height: '100%',
          overflow: 'hidden'
        }}>
        <div className={'d-flex justify-content-end'}>
          {receivedTradeStatus === 'Draft'
            ? generateTitleById(
                '0a1b2c3d-4e5f-6a7b-8c9d-0e1f2a3b4c5d',
                gameDocument,
                displayLanguageContext.displayLanguageSelected.resources!,
                'game'
              ) || 'Draft'
            : generateTitleById(
                '1b2c3d4e-5f6a-7b8c-9d0e-1f2a3b4c5d6e',
                gameDocument,
                displayLanguageContext.displayLanguageSelected.resources!,
                'game'
              ) || 'Pending'}
        </div>
        <div className={'d-flex flex-grow-1 overflow-auto flex-wrap gap-2'}>
          {receivedItems
            .filter((item) => !item.hideInGame)
            .map((item) => (
              <TradeCard
                key={item.id}
                item={item}
                isLocked={false}
                showModal={() => showModal(item)}
              />
            ))}
        </div>
      </div>
    </>
  );
};

export default ReceivedItems;
